module.exports = __webpack_public_path__ + "static/media/Icon -  smart appliances.0cde9cda.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/elements/Icon -  smart appliances.svg
// module id = 42
// module chunks = 0